import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import CircularProgress from '@material-ui/core/CircularProgress';

import Skeleton from '@material-ui/lab/Skeleton';

import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import FindInPageIcon from '@material-ui/icons/FindInPage';
import DescriptionIcon from '@material-ui/icons/Description';
import GetAppIcon from '@material-ui/icons/GetApp';

import Config from '../../constants/appConfig';
import MaterialIcon from '../../components/MaterialIcon';

import { notification } from 'antd';

import { useParams } from "react-router";


const styles = theme => ({});

class List extends React.Component {
    state = {
        jobs: [],
        expandedYears: {},
        filteredJobs: [],
        selectedMonths: {},
        reports: [],
        selectedJobs: new Set(),
        selectedJobsByYear: {},
        downloading: null,
        isLoading: true,
    };

    componentDidMount() {
        this.readJobDetail();
        this.readReports();

        const savedSelectedJobsByYearString = localStorage.getItem('selectedJobsByYear');
        if (savedSelectedJobsByYearString) {
            const savedSelectedJobsByYear = JSON.parse(savedSelectedJobsByYearString);

            if (savedSelectedJobsByYear && typeof savedSelectedJobsByYear === 'object') {
                const selectedJobsByYear = Object.fromEntries(
                    Object.entries(savedSelectedJobsByYear).map(([year, jobArray]) => {
                        if (Array.isArray(jobArray)) {
                            return [year, new Set(jobArray)];
                        } else {
                            return [year, new Set()];
                        }
                    })
                );

                this.setState({ selectedJobsByYear });
            }
        }
    }

    componentWillUnmount() {
        // fix Warning: Can't perform a React state update on an unmounted component
        this.setState = (state, callback) => {
            return;
        };
    };

    readJobDetail = () => {
        const apiUrl = `${Config.server}/job_detail`;

        const options = {
            method: 'GET',
            headers: {
                'Authorization': localStorage.getItem('access-token-jwt')
            }
        };

        fetch(apiUrl, options)
            .then((res) => {
                if (res.status !== 200) throw res;
                else return res.json();
            })
            .then((result) => {
                this.setState(prevState => {
                    const updatedSelectedJobsByYear = { ...prevState.selectedJobsByYear };
                    result.forEach(job => {
                        const year = new Date(job.startDate).getFullYear();
                        if (!updatedSelectedJobsByYear[year]) {
                            updatedSelectedJobsByYear[year] = new Set();
                        }
                    });
                    return { jobs: result, selectedJobsByYear: updatedSelectedJobsByYear, isLoading: false }
                })
            })
            .catch((error) => {
                if (error.status === 405) {
                    notification.open({
                        message: this.props.res.PERMISSAO,
                        description: this.props.res.PERMISSAO_MSG,
                        icon: <MaterialIcon icon="error" className="text-danger" />
                    });
                } else if (error.status === 401 || error.status === 403) {
                    this.props.link('/login');
                } else {
                    notification.open({
                        message: this.props.res.ERRO,
                        description: this.props.res.ERRO_MSG,
                        icon: <MaterialIcon icon="error" className="text-danger" />
                    });
                }
            });
    };

    toggleYearExpand = (year) => {
        this.setState(prevState => ({
            expandedYears: {
                ...prevState.expandedYears,
                [year]: !prevState.expandedYears[year],
            },
        }));
    };

    renderMonths = (year) => {
        const { res, link } = this.props;

        const months = ['JAN', 'FEV', 'MAR', 'ABR', 'MAI', 'JUN', 'JUL', 'AGO', 'SET', 'OUT', 'NOV', 'DEZ'];
        const selectedMonth = this.state.selectedMonths[year];

        const isPreOrcamento = (job) => {
            const t = String(job.type || '').toLowerCase();
            return t === 'pre_orcamento' || t === 'pre-orcamento';
        };
        const isOS = (job) => String(job.type || '').toLowerCase() === 'ordem_servico';

        const parseDate = (v) => (v ? new Date(v) : null);
        const inYearMonth = (d, y, m) => d && d.getFullYear() === y && d.getMonth() === m;

        const getOSCreatedDates = (job) => {
            const arr = Array.isArray(job.service_order) ? job.service_order : [];
            return arr.map(it => parseDate(it && it.created)).filter(Boolean);
        };

        const getNonOSStart = (job) =>
            parseDate(job.startDate || job.start || job.created || job.updated);

        const getNonOSEnd = (job) =>
            parseDate(job.endDate || job.end || job.updated || job.created);

        const hitsMonth = (job, y, m) => {
            if (selectedMonth === undefined) return false;
            if (isPreOrcamento(job)) return false;
            if (isOS(job)) {
                const dates = getOSCreatedDates(job);
                if (dates.length === 0) return false;
                return dates.some(d => inYearMonth(d, y, m));
            }
            const d = getNonOSStart(job);
            return d ? inYearMonth(d, y, m) : false;
        };

        const sortKey = (job) => {
            if (isOS(job)) {
                const dates = getOSCreatedDates(job);
                if (dates.length > 0) return Math.max(...dates.map(d => d.getTime()));
                return parseDate(job.updated || job.created)?.getTime() || 0;
            }
            return getNonOSEnd(job)?.getTime() || 0;
        };

        let filteredJobs = this.state.jobs
            .filter(job => hitsMonth(job, year, selectedMonth))
            .sort((a, b) => sortKey(b) - sortKey(a));

        const jobIdsWithReports = filteredJobs
            .filter(job => this.state.reports.some(r => r.id_job === job.id))
            .map(job => job.id);

        const areAllJobsSelected =
            jobIdsWithReports.length > 0 &&
            jobIdsWithReports.every(id => this.state.selectedJobsByYear[year]?.has(id));

        const formatTimestampToDateTime = (ts) => {
            if (!ts) return '';
            const d = new Date(ts);
            const dd = d.getDate();
            const mm = d.getMonth() + 1;
            const yyyy = d.getFullYear();
            const hh = ('00' + d.getHours()).slice(-2);
            const mi = ('00' + d.getMinutes()).slice(-2);
            return `${dd}/${mm}/${yyyy} ${hh}:${mi}`;
        };

        const formatDateOnly = (ts) => {
            if (!ts) return '';
            const d = new Date(ts);
            const dd = d.getDate();
            const mm = d.getMonth() + 1;
            const yyyy = d.getFullYear();
            return `${dd}/${mm}/${yyyy}`;
        };

        const pickPrimarySOItem = (job) => {
            const arr = Array.isArray(job.service_order) ? job.service_order.slice() : [];
            if (arr.length === 0) return null;
            arr.sort((a, b) => {
                const da = parseDate(a.created || a.so_created || a.job_date) || new Date(0);
                const db = parseDate(b.created || b.so_created || b.job_date) || new Date(0);
                return da - db;
            });
            return arr[0];
        };

        return (
            <TableRow key={`months-${year}`}>
                <TableCell colSpan={9} style={{ textAlign: 'center', padding: '0.5rem 1rem' }}>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <div style={{ display: 'flex', justifyContent: 'end', marginBottom: '1rem' }}>
                            <Button
                                variant="contained"
                                color="primary"
                                style={{ paddingTop: '0.7rem' }}
                                onClick={() => this.downloadRelMAPA(year)}
                                className="popUpButton"
                                title={res.BAIXAR_RELATORIO_ANUAL}
                                disabled={this.state.downloading === year}
                            >
                                {this.state.downloading === year ? <CircularProgress size={24} /> : <GetAppIcon className="iconMapS" />}
                            </Button>
                        </div>

                        <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
                            {months.map((month, index) => (
                                <Button
                                    key={`${year}-${month}`}
                                    variant='contained'
                                    style={{ margin: '0.5rem', fontWeight: '600' }}
                                    onClick={() => this.handleMonthClick(year, index)}
                                    color={selectedMonth === index ? 'primary' : 'default'}
                                >
                                    {month}
                                </Button>
                            ))}
                        </div>

                        {selectedMonth !== undefined ? (
                            filteredJobs.length > 0 ? (
                                <Table style={{ marginTop: '2rem' }}>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell padding="checkbox">
                                                <Checkbox
                                                    indeterminate={jobIdsWithReports.length > 0 && !areAllJobsSelected}
                                                    checked={areAllJobsSelected}
                                                    onChange={this.handleSelectAllJobs(year, selectedMonth)}
                                                    disabled={jobIdsWithReports.length === 0}
                                                />
                                            </TableCell>
                                            <TableCell>{res.TIPO}</TableCell>
                                            <TableCell>{res.TITULO}</TableCell>
                                            <TableCell>{res.CLIENTE}</TableCell>
                                            <TableCell>{res.AREA_EXECUTADA}</TableCell>
                                            <TableCell>{res.DATA_INICIO}</TableCell>
                                            <TableCell>{res.DATA_FIM}</TableCell>
                                            <TableCell>{res.AERONAVE}</TableCell>
                                            <TableCell>{res.PILOTO}</TableCell>
                                            <TableCell>{res.ACOES}</TableCell>
                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        {filteredJobs.map((job) => {
                                            const type = String(job.type || '').toLowerCase();
                                            const os = isOS(job);
                                            const soItem = os ? pickPrimarySOItem(job) : null;
                                            const isReportAvailable = this.state.reports.some(r => r.id_job === job.id);
                                            const defaultTitle =
                                                job.title ||
                                                job.title_job_po ||
                                                '';
                                            const defaultClient =
                                                job.client_name ||
                                                job.client_job_po ||
                                                '';
                                            const defaultArea =
                                                job.spray ||
                                                job.area_ha_job_po ||
                                                null;
                                            const defaultStart =
                                                job.startDate || job.start || job.created || job.updated;
                                            const defaultEnd =
                                                job.endDate || job.end || job.updated || job.created;
                                            const title = os ? (job.title || '') : defaultTitle;
                                            const client = os ? (soItem && (soItem.so_client || '')) : defaultClient;
                                            const area = os ? (soItem && (soItem.area != null) ? soItem.area : null) : defaultArea;
                                            const startDisplay = os ? (soItem ? formatDateOnly(soItem.job_date) : '') : formatTimestampToDateTime(defaultStart);
                                            const endDisplay = os ? '' : formatTimestampToDateTime(defaultEnd);
                                            const plane = os ? (soItem && soItem.plane) || '' : (job.plane_name || '');
                                            const pilot = os ? (soItem && soItem.pilot) || '' : (job.pilot_name || '');

                                            return (
                                                <TableRow key={job.id}>
                                                    <TableCell padding="checkbox">
                                                        <Checkbox
                                                            checked={this.state.selectedJobsByYear[year] && this.state.selectedJobsByYear[year].has(job.id) && isReportAvailable}
                                                            onChange={() => this.handleSelectJob(year, job.id)}
                                                            disabled={!isReportAvailable}
                                                            style={{ display: os ? 'none' : 'inline-block' }}
                                                        />
                                                    </TableCell>

                                                    <TableCell>
                                                        {os ? res.ORDEM_SERVICO : res.RELATORIO}
                                                    </TableCell>

                                                    <TableCell>{title}</TableCell>
                                                    <TableCell>{client}</TableCell>
                                                    <TableCell>{area != null ? `${area} ha` : ''}</TableCell>
                                                    <TableCell>{startDisplay}</TableCell>
                                                    <TableCell>{endDisplay}</TableCell>
                                                    <TableCell>{plane}</TableCell>
                                                    <TableCell>{pilot}</TableCell>
                                                    <TableCell>
                                                        <Button
                                                            style={{ marginRight: '0.5rem' }}
                                                            variant="contained"
                                                            color={isReportAvailable ? "primary" : "inherit"}
                                                            title={res.GERAR_RELATORIO}
                                                            onClick={() => (link('/app/relatorio-mapa/edit/' + job.id))}
                                                        >
                                                            <DescriptionIcon />
                                                        </Button>
                                                        <Button
                                                            variant="contained"
                                                            color={(type === 'report' || type === 'analise' || os) ? "primary" : "inherit"}
                                                            style={{ cursor: (type === 'report' || type === 'analise' || os) ? 'pointer' : 'not-allowed' }}
                                                            onClick={() => (
                                                                type === 'report' ? link(`/app/relatorio/${job.guid}`) :
                                                                    type === 'analise' ? link(`/app/qualidade/${job.guid}`) :
                                                                        os ? link(`/app/ordem-servico/edit/${job.service_order[0].id_service_order}`) :
                                                                            null
                                                            )}
                                                            title={
                                                                type === 'analise' ? res.IR_QUALIDADE :
                                                                    os ? res.IR_ORDEM_SERVICO :
                                                                        type === 'report' ? res.IR_RELATORIO : ''
                                                            }
                                                        >
                                                            <FindInPageIcon />
                                                        </Button>
                                                    </TableCell>
                                                </TableRow>
                                            );
                                        })}
                                    </TableBody>
                                </Table>
                            ) : (
                                <div style={{ marginTop: '2rem' }}>{res.SEM_TRABALHOS}</div>
                            )
                        ) : (
                            <div style={{ marginTop: '2rem' }}>{res.SELECIONAR_MES}</div>
                        )}
                    </div>
                </TableCell>
            </TableRow>
        );
    };

    handleMonthClick = (year, index) => {
        this.setState(prevState => {
            const yearSelected = prevState.selectedMonths[year] === index ? null : index;
            const updatedSelectedMonths = {
                ...prevState.selectedMonths,
                [year]: yearSelected,
            };

            return { selectedMonths: updatedSelectedMonths };
        });
    };

    readReports = () => {
        const apiUrl = `${Config.server}/reports_mapa`;

        const options = {
            method: 'GET',
            headers: {
                'Authorization': localStorage.getItem('access-token-jwt')
            }
        };

        fetch(apiUrl, options)
            .then((res) => {
                if (res.status !== 200) throw res;
                else return res.json();
            })
            .then((result) => {
                this.setState(prevState => {
                    const selectedJobsByYear = { ...prevState.selectedJobsByYear };
                    result.forEach(report => {
                        const job = prevState.jobs.find(job => job.id === report.id_job);
                        if (job) {
                            const year = new Date(job.startDate).getFullYear();
                            if (!selectedJobsByYear[year]) {
                                selectedJobsByYear[year] = new Set();
                            }
                            selectedJobsByYear[year].add(job.id);
                        }
                    });

                    return {
                        reports: result,
                        selectedJobsByYear: selectedJobsByYear,
                    };
                });
            })
            .catch((error) => {
                if (error.status === 405) {
                    notification.open({
                        message: this.props.res.PERMISSAO,
                        description: this.props.res.PERMISSAO_MSG,
                        icon: <MaterialIcon icon="error" className="text-danger" />
                    });
                } else if (error.status === 401 || error.status === 403) {
                    this.props.link('/login');
                }
            });
    };

    getYear = (jobs) => {
        const years = new Set();
        jobs.forEach(job => {
            if (job.startDate) {
                years.add(new Date(job.startDate).getFullYear());
            }
        });
        return Array.from(years);
    };

    downloadRelMAPA = (year) => {
        this.setState({ downloading: year });
        let apiUrl = Config.server + '/relmapaPlanilha';
        const formData = new URLSearchParams();

        const selectedYearJobs = this.state.jobs.filter(job =>
            this.state.selectedJobsByYear[year] &&
            this.state.selectedJobsByYear[year].has(job.id) &&
            new Date(job.startDate).getFullYear() === year
        );
        const filteredReports = this.state.reports.filter(report =>
            selectedYearJobs.find(job => job.id === report.id_job)
        );

        formData.append('jobData', JSON.stringify(selectedYearJobs));
        formData.append('jobReport', JSON.stringify(filteredReports));
        formData.append('year', year);

        let options = {
            method: 'POST',
            body: formData,
            headers: {
                'Authorization': localStorage.getItem('access-token-jwt'),
            }
        };

        fetch(apiUrl, options)
            .then(res => {
                if (res.status !== 200) throw res;
                return res.blob();
            })
            .then(blob => {
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = `Relatorio-MAPA-${year}.xlsx`;
                document.body.appendChild(a);
                a.click();
                a.remove();
                window.URL.revokeObjectURL(url);
                this.setState({ downloading: null });
            })
            .catch((error) => {
                notification.open({
                    message: this.props.res.ERRO,
                    description: this.props.res.ERRO_MSG,
                    icon: <MaterialIcon icon="error" className="text-danger" />
                });
                this.setState({ downloading: null });
            });
    };

    handleSelectJob = (year, jobId) => {
        this.setState(prevState => {
            const updatedJobSet = new Set(prevState.selectedJobsByYear[year] || new Set());

            if (updatedJobSet.has(jobId)) {
                updatedJobSet.delete(jobId);
            } else {
                updatedJobSet.add(jobId);
            }

            const newSelectedJobsByYear = { ...prevState.selectedJobsByYear, [year]: updatedJobSet };

            localStorage.setItem('selectedJobsByYear', JSON.stringify(
                Object.fromEntries(
                    Object.entries(newSelectedJobsByYear).map(([year, jobSet]) => [year, Array.from(jobSet)])
                )
            ));

            return {
                selectedJobsByYear: newSelectedJobsByYear,
            };
        });
    };

    handleSelectAllJobs = (year, month) => event => {
        const isChecked = event.target.checked;
        this.setState(prevState => {
            const updatedJobSet = new Set(prevState.selectedJobsByYear[year]);
            const reportAvailableJobs = this.state.jobs
                .filter(job => {
                    const jobDate = new Date(job.startDate);
                    return jobDate.getFullYear() === year && jobDate.getMonth() === month && this.state.reports.some(report => report.id_job === job.id);
                });

            reportAvailableJobs.forEach(job => {
                if (isChecked) {
                    updatedJobSet.add(job.id);
                } else {
                    updatedJobSet.delete(job.id);
                }
            });

            const newSelectedJobsByYear = { ...prevState.selectedJobsByYear, [year]: updatedJobSet };

            localStorage.setItem('selectedJobsByYear', JSON.stringify(
                Object.fromEntries(
                    Object.entries(newSelectedJobsByYear).map(([year, jobSet]) => [year, Array.from(jobSet)])
                )
            ));

            return {
                selectedJobsByYear: newSelectedJobsByYear,
            };
        });
    };

    render() {
        const { res } = this.props;

        return (
            <div>
                <div>
                    <h1>{res.RELATORIO_MAPA}</h1>
                </div>
                <div>
                    {this.state.isLoading
                        ?
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>
                                        <Skeleton variant="text" width="100%" height={40} />
                                    </TableCell>
                                    <TableCell>
                                        <Skeleton variant="text" width="100%" height={40} />
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {[...Array(3)].map((_, index) => (
                                    <React.Fragment key={index}>
                                        <TableRow>
                                            <TableCell style={{ width: '96%' }}>
                                                <Skeleton variant="text" width="100%" height={40} />
                                            </TableCell>
                                            <TableCell style={{ width: '4%', textAlign: 'center' }}>
                                                <Skeleton variant="circular" width={24} height={24} />
                                            </TableCell>
                                        </TableRow>
                                    </React.Fragment>
                                ))}
                            </TableBody>
                        </Table>
                        :
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell></TableCell>
                                    <TableCell></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {this.getYear(this.state.jobs).sort((a, b) => b - a).map((year) => (
                                    <React.Fragment key={year}>
                                        <TableRow onClick={() => this.toggleYearExpand(year)}>
                                            <TableCell style={{ width: '96%', borderBottom: this.state.expandedYears[year] ? 'none' : '' }}>
                                                <h2 style={{ fontSize: '1.75rem' }}>{year}</h2>
                                            </TableCell>
                                            <TableCell style={{ width: '4%', textAlign: 'center', borderBottom: this.state.expandedYears[year] ? 'none' : '' }}>
                                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>


                                                    {this.state.expandedYears[year]
                                                        ?
                                                        <KeyboardArrowUpIcon className="iconMapS" />
                                                        :
                                                        <KeyboardArrowDownIcon className="iconMapS" />
                                                    }
                                                </div>
                                            </TableCell>
                                        </TableRow>
                                        {this.state.expandedYears[year] ? this.renderMonths(year) : null}
                                    </React.Fragment>
                                ))}
                            </TableBody>
                        </Table>
                    }
                </div>
            </div>
        );
    }
}

List.propTypes = {
    classes: PropTypes.object.isRequired,
};

const TextFields1 = withStyles(styles)(List);

const Box = (props) => {
    const { link, res } = props;
    let { id } = useParams();
    return (
        <div className="rowForm">
            <div className="divContent">
                <TextFields1 link={link} id={id} res={res} />
            </div>
        </div>)
}

export default Box;